export enum SessionStorageKeys {
  ExternalChannelOffer = 'external_channel_offer',
  UtmCampaign = 'utmCampaign',
  UtmMedium = 'utmMedium',
  UtmSource = 'utmSource',
  UtmTerm = 'utmTerm',
  UtmContent = 'utmContent',
}
